import { render, staticRenderFns } from "./separateCase.vue?vue&type=template&id=678d6e1e&"
import script from "./separateCase.vue?vue&type=script&lang=js&"
export * from "./separateCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports